/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type FinancialCalculationTrigger_viewer = {
    readonly project: {
        readonly id: string;
        readonly financialCalculationTrigger: {
            readonly timestamp: number | null;
            readonly duration: number | null;
            readonly isSmallProject: boolean | null;
        } | null;
    } | null;
    readonly " $refType": "FinancialCalculationTrigger_viewer";
};
export type FinancialCalculationTrigger_viewer$data = FinancialCalculationTrigger_viewer;
export type FinancialCalculationTrigger_viewer$key = {
    readonly " $data"?: FinancialCalculationTrigger_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"FinancialCalculationTrigger_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "ID!"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FinancialCalculationTrigger_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialCalculationTrigger",
          "kind": "LinkedField",
          "name": "financialCalculationTrigger",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timestamp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "duration",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSmallProject",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '0c635187570cf003cfe9df1651b09431';
export default node;
